import { PaginatedListSchema } from '../shared/paginatedList';
import { createPageListQueryValidationSchema } from '../page/list';
import { FormPageMcpPayloadSchema, FormPageToolDataValidationSchema } from './response';

export const FormPageListQueryValidationSchema = createPageListQueryValidationSchema(
  "Case-insensitive contains match against the form's internal name and title. Searching 'waitlist' matches a form titled 'Join the waitlist'. There is no filter by field, file or slug: page through and inspect those fields instead.",
);

export const GetFormPagesResponseValidationSchema = PaginatedListSchema(FormPageMcpPayloadSchema);

export const FormPagesToolResponseValidationSchema = PaginatedListSchema(
  FormPageToolDataValidationSchema,
);
